export const REGISTER_LISTENERS = "registerListeners";
export const UNREGISTER_LISTENERS = "unregisterListeners";
export const ADD_OR_IGNORE_UNSEEN_CONTENT = "addOrIgnoreUnseenContent";
export const REMOVE_BY_TYPE_AND_TOPICS = "removeByTypeAndTopics";
